import React from 'react';
import { withRouter } from 'react-router-dom';
import { appConfig } from '../../config';
import { AppLayoutDefault } from './default/AppLayoutDefault';
import { AppLayoutDisona } from './disona/AppLayoutDisona';

function AppLayout(props) {
  switch (appConfig.whiteLabelPartner) {
    case 'disona': {
      return <AppLayoutDisona {...props} />;
    }
    default: {
      return <AppLayoutDefault {...props} />;
    }
  }
}

export default withRouter(AppLayout);
